import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  modal: {
    width: "fit-content",
    padding: theme.spacing(8),
    border: "2px solid #DADADA",
    borderRadius: 10,
    boxSizing: "border-box",
    [theme.breakpoints.down("md")]: {
      width: 312,
      height: 350,
      maxWidth: "100%",
      padding: theme.spacing(5),
    },
  },
  container: {
    display: "flex",
    justifyContent: "center",
    gap: theme.spacing(7),
    [theme.breakpoints.down("md")]: {
      gap: theme.spacing(4),
    },
  },
  thumbnail: {
    width: 321,
    height: 321,
    borderRadius: 10,
    objectFit: "cover",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  content: {
    width: 309,
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  contentInner: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(7),
    [theme.breakpoints.down("md")]: {
      gap: theme.spacing(4),
    },
  },
  heading: {
    fontSize: "1.63rem",
    fontWeight: 700,
    [theme.breakpoints.down("md")]: {
      fontSize: "1.38rem",
    },
  },
  message: {
    fontSize: "1rem",
    fontWeight: 500,
    textWrap: "balance",
    [theme.breakpoints.down("md")]: {
      fontSize: "0.88rem",
    },
  },
  form: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(4),
  },
  input: {
    width: "100%",
    "& .MuiOutlinedInput-notchedOutline": {
      boxShadow: "none",
      borderRadius: 10,
      borderColor: theme.palette.primary.main,
    },
    [theme.breakpoints.down("md")]: {
      "& .MuiOutlinedInput-notchedOutline": {
        borderRadius: 5,
      },
    },
  },
  button: {
    width: "100%",
    height: 46,
    fontSize: "1rem",
    [theme.breakpoints.down("md")]: {
      fontSize: "0.88rem",
      height: 34,
    },
  },
  footer: {
    [theme.breakpoints.down("md")]: {
      display: "flex",
      gap: theme.spacing(4),
      marginTop: theme.spacing(3.5),
    },
  },
  mobileThumbnail: {
    display: "none",
    [theme.breakpoints.down("md")]: {
      display: "block",
      width: 81,
      height: 71,
      borderRadius: 10,
      objectFit: "cover",
    },
  },
  brandContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(3),
    alignSelf: "flex-start",
    [theme.breakpoints.down("md")]: {
      alignSelf: "flex-end",
    },
  },
  brandText: {
    fontSize: "0.75rem",
    fontWeight: 500,
    color: "#767676",
  },
}));
